import { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';

const DEFAULT_MESSAGE = 'Not available on your current plan -- upgrade to unlock this feature.';

/**
 * Wraps an already-disabled control so hovering it explains why, instead of
 * it just looking broken. Needs its own `<span>` trigger (rather than
 * wrapping the control directly) because a disabled control has
 * `pointer-events: none`, which would stop the tooltip from ever seeing the
 * hover in the first place.
 */
export function UpgradeTooltip({
  children,
  message = DEFAULT_MESSAGE,
  side,
}: {
  children: ReactNode;
  message?: string;
  /** Inside menus pass "left" so the tooltip doesn't cover the neighbouring items. Defaults to above. */
  side?: 'top' | 'right' | 'bottom' | 'left';
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className="inline-flex">{children}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs" side={side} sideOffset={side ? 8 : undefined}>{message}</TooltipContent>
    </Tooltip>
  );
}

export default UpgradeTooltip;
